/**
 * HelperText — small muted text shown below a control to explain state.
 * Lower visual weight than FieldLabel so it doesn't compete with the control.
 */

import type { CSSProperties, ReactNode } from "react";

interface HelperTextProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function HelperText({ children, style }: HelperTextProps) {
  return (
    <span
      style={{
        display: "block",
        marginTop: 4,
        fontSize: 11,
        fontWeight: 400,
        color: "#a3a3a3",
        lineHeight: 1.4,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
